import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { getModel } from '@smx-ui-model/store-model';
import { GenericModelSchemaType, StoreModelType } from '@smx-ui-model/types';
import { Flex } from 'antd';
import { memo } from 'react';

import { EntityWrapperTableCell } from './cells/entity-wrapper-table-cell';

interface EntityTableRowProps<C> {
    modelName: keyof StoreModelType;
    node?: any;
    contextName?: C;
}

export const EntityTableRowSetColumn = memo(<C,>({ modelName, node, contextName }: EntityTableRowProps<C>) => {
    const model = getModel<GenericModelSchemaType>(modelName);
    const dataEntity = useFragmentFromStore<any>(node);

    const listColumnName = contextName ? model.context?.[contextName] || [] : model.schema.context.table;

    return (
        <>
            {listColumnName.map((columnName) => {
                const field = (model.schema.field as any)[columnName];

                return (
                    <td key={columnName}>
                        <Flex vertical style={{ maxHeight: 200, overflow: 'auto' }}>
                            <EntityWrapperTableCell
                                schemaData={field}
                                model={model}
                                fieldData={dataEntity[columnName]}
                                dataEntity={dataEntity}
                            />
                        </Flex>
                    </td>
                );
            })}
        </>
    );
});
